import React from 'react';
import Box from '@mui/material/Box';

export interface AdminAvatarProps {
  name: string;
  size?: number;
  muted?: boolean;
}

export const initialsOf = (name: string): string => {
  const parts = name.replace(/[@._-]+/g, ' ').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0] ?? '?').slice(0, 2).toUpperCase();
};

export const AdminAvatar: React.FC<AdminAvatarProps> = ({ name, size = 32, muted }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: muted ? 'action.hover' : 'action.selected',
      color: muted ? 'text.disabled' : 'text.primary',
      fontSize: size >= 40 ? 14 : size >= 32 ? 12 : 10,
      fontWeight: 600,
      lineHeight: 1,
    }}
  >
    {initialsOf(name)}
  </Box>
);

export default AdminAvatar;
